import { JwtResponse, Login } from "@/types";
import { User } from "@/types";
import { getData, postData, putData, deleteData } from "./axios-service";
import { ResetPassword } from "@/types/reset-password";

function modelMapper(inputUser: any): User {
    const firstname = inputUser.firstname || "";
    const lastname = inputUser.lastname || "";
    return {
        id: inputUser.id,
        firstname,
        lastname,
        username: inputUser.username,
        email: inputUser.email,
        telephone: inputUser.telephone,
        avatar: inputUser.avatar,
        roles: inputUser.roles,
        mobile: inputUser.mobile,
        fonction: inputUser.fonction,
        technical: inputUser.technical,
        assignedMobileDevice: inputUser.assignedMobileDevice,
        fullName: `${firstname} ${lastname}`.trim()
    };
}

export function modelMapperArray(inputArray: any[]): User[] {
    return inputArray.map(modelMapper);
}

export async function getAllUsers(): Promise<User[]> {
    const users = await getData<User[]>("/users");
    return modelMapperArray(users ?? []);
}

export async function getAllTechnicians(): Promise<User[]> {
    const users = await getData<User[]>("/users?technical=true");
    return modelMapperArray(users ?? []);
}

export async function getUserById(id: string): Promise<User> {
    const user = await getData<User>(`/users/${id}`);
    return modelMapper(user);
}


export function postUser(user: User): Promise<any> {
    return postData("/users", user)
}

export function postSignin(login: Login): Promise<JwtResponse> {
    return postData("/aqua-users/auth/login", login)
}

export function postRefresh(): Promise<JwtResponse> {
    return postData("/aqua-users/auth/refresh");
}

export function postForgotPassword(email: string): Promise<any> {
    return postData("/aqua-users/auth/forgot-password", { email });
}

export function postResetPassword(resetPassword: ResetPassword): Promise<any> {
    return postData("/aqua-users/auth/reset-password", resetPassword)
}

export function putUser(id: string, user: User): Promise<any> {
    return putData("/users/" + id, user)
}

export function deleteUser(ids: string[]): Promise<any> {
    const idsStr = ids.join(',');
    return deleteData("/users/" + idsStr)
}

export function changePassword(id: string, currentPassword: string, newPassword: string): Promise<any> {
    return putData(`/users/${id}/change-password`, { currentPassword, newPassword });
}

export async function searchForUsers(searchQuery: string): Promise<User[]> {
    const users = await getData<User[]>(`/users?${searchQuery}`);
    return modelMapperArray(users ?? []);
}
